function percentageChange(earlier: number, later: number): number | null {
  if (earlier === 0) return null
  return (later - earlier) / earlier
}

export function getAnnualChange<Datum extends Record<string, any>>(
  data: Datum[],
  getYear: (x: Datum) => number,
  getAmount: (x: Datum) => number,
): {
  current: number
  previous: number
  change: number | null
} {
  const [previous, current] = data
    .sort((a, b) => getYear(a) - getYear(b))
    .map(getAmount)
    .slice(0, 2)

  return {
    current,
    previous,
    change: percentageChange(previous, current),
  }
}

export function getCurrentAmountOnly<Datum extends Record<string, any>>(
  data: Datum[],
  getAmount: (x: Datum) => number,
  // getYear: (x: Datum) => number,
): {
  current: number
} {
  const [current] = data.slice(0, 1).map(getAmount)

  return {
    current,
  }
}
